const carousel = $('.product-details-slider-wr').find('.carousel');
// const thumbnail = $('.carousel-indicators');

document.addEventListener('DOMContentLoaded', () => {
  carousel.carousel({
    interval: false,
  });
});
